import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class PainScaleAPI extends ComponentAPI {
    getScaleType() {
        return this.state.scaleType;
    }
    setScaleType(scaleType) {
        this.setState({ scaleType });
    }
    getScaleOpen() {
        return this.state.scaleOpen;
    }
    setScaleOpen(scaleOpen) {
        this.setState({ scaleOpen });
    }
    getValue() {
        return this.state.value;
    }
    setValue(value) {
        this.setState({ value });
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
}
export default PainScaleAPI;
//# sourceMappingURL=pain-scale-api.js.map